module.exports = __webpack_public_path__ + "img/kgz.614bd936.jpg";